// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__RyTcX","total":"MasterSaleDetails_total__zykRf","edit":"MasterSaleDetails_edit__HxAK6","cancel":"MasterSaleDetails_cancel__nQXsp"};